import React, { FC } from 'react';
import { G, Line } from 'react-native-svg';
import {
  ERASER_STRIKE_COLOR,
  ERASER_STRIKE_OPACITY,
  ERASER_STRIKE_PADDING,
  ERASER_STRIKE_WIDTH,
} from '../../constants';
import { getBBox } from '@v2/components/imageHandling/components/DrawingCanvas/helpers';
import { Annotation } from '@v2/components/imageHandling/components/DrawingCanvas/types';

interface EraserStrikethroughProps {
  annotation: Annotation;
}

const EraserStrikethrough: FC<EraserStrikethroughProps> = ({ annotation }) => {
  const bbox = getBBox(annotation);
  if (!bbox) return null;
  const x1 = bbox.x - ERASER_STRIKE_PADDING;
  const y1 = bbox.y - ERASER_STRIKE_PADDING;
  const x2 = bbox.x + bbox.width + ERASER_STRIKE_PADDING;
  const y2 = bbox.y + bbox.height + ERASER_STRIKE_PADDING;
  return (
    <G>
      <Line x1={x1} y1={y1} x2={x2} y2={y2} stroke={ERASER_STRIKE_COLOR} strokeWidth={ERASER_STRIKE_WIDTH} opacity={ERASER_STRIKE_OPACITY} strokeLinecap="round" />
      <Line x1={x2} y1={y1} x2={x1} y2={y2} stroke={ERASER_STRIKE_COLOR} strokeWidth={ERASER_STRIKE_WIDTH} opacity={ERASER_STRIKE_OPACITY} strokeLinecap="round" />
    </G>
  );
};

export default EraserStrikethrough;
